module.exports = __webpack_public_path__ + "img/Veranza-16-min.9de63cb6.jpg";